interface USGLogoProps {
  size?: number;
}

export function USGLogo({ size = 44 }: USGLogoProps) {
  return (
    <img
      src="/usg-logo.svg"
      alt="Urban Solution Group"
      style={{ height: size, width: "auto", display: "block" }}
    />
  );
}
